import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import LadgerHome from './LadgerHome';
import { Breadcrumbs } from '../../AbstractElements';
import React, { Fragment } from 'react';
import { useTranslation } from "react-i18next";

export default function LadgerList() {
    const { t } = useTranslation();
    return (
        <Fragment>
            
            <Breadcrumbs mainTitle={t("List of Patient Ledgers")} parent={t("Home")} title={t("List of Patient Ledgers")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <LadgerHome />
                    </Col>
                </Row>
            </Container>

        </Fragment>
    )
}
